import React, { useState } from 'react';
import { Button, Label, ModalBody, ModalFooter, Row, Col, Modal, ModalHeader, Input } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ModalCrudGlobalComment } from './ModalCrudGlobalComment';
import { Dialog } from 'primereact/dialog';
import { TitleDataTable } from '../tableDataTable/TitleDataTable';
import { AlertDataTable } from '../tableDataTable/AlertDataTable';

export const ModalTableGlobalComment = (props) => {
    const {
        toggleTableGlobalComment, modalTableGlobalComment, method, handleCreateGlobalComment, modalCrudComment, toggleCrudComment,
        saveCreate, handleInputChange, text, type, comments,handleInsert, handleDeleteCommentText, loading, search, setSearch,keyComments, modalAlert, showDeleteAlert, loadingExport, handleClear, handleSearch,

        saveDeleteComment, closeDeleteAlertText, openDeleteAlertText, setIdDelete, handleExportExcelComment,
        searchComment, closeDialogComments
    } = props;
        // console.log("🚀 ~ ModalTableGlobalComment ~ keyComments:", keyComments)
    const [selectedComment, setSelectedComment] = useState(null);
    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
             
            {/* <Button outline color="primary" size="sm" onClick={() => handleInsert(rowData)} className='mr-2' disabled={loading}>
                <i className="fa fa-plus"></i>
            </Button>

            <Button outline color="danger" size="sm" onClick={() => handleDeleteCommentText(rowData.id_global_comment_text)} disabled={loading}>
                <i className="fa fa-trash"></i>
            </Button> */}

            <Button
                color="primary"
                size="sm"
                onClick={() => handleInsert(rowData)}
                disabled={loading}
                style={{
                    padding: "2px",
                    fontSize: "1rem",
                    height: "26px",
                    width: "26px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}

            >
                <i className="fa fa-plus"></i>
            </Button>


            <Button
                color="danger"
                size="sm"
                onClick={() => {
                    setIdDelete(rowData.id_global_comment_text);
                    setSelectedComment(rowData);
                    openDeleteAlertText();
                }}
                disabled={loading}
                style={{
                    padding: "2px",
                    fontSize: "1rem",
                    height: "26px",
                    width: "26px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <i className="fa fa-trash"></i>
            </Button>
        </div>
        );
    };

      const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    return (
        <>
        <Dialog 
            header="Comentarios Globales"
            visible={modalTableGlobalComment}
            onHide={closeDialogComments}
            key={`id_modall-${keyComments}`}
            closable={true}
            modal
            blockScroll
            className='large-dialog'
        >               
                <Row className="d-flex justify-content-between">

                     <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                        <TitleDataTable
                            titleTable="Comentarios Globales"
                            buttonActions={handleExportExcelComment}
                            titleButton="Excel de comentrios globales"
                            isDisbled={loadingExport}
                            loadingIsDisabled={loadingExport}
                            titleCreate="Crear Laboratorio"
                            buttonActionsCreate={toggleCrudComment}
                            actionInput={handleSearch}
                            valueFilter={searchComment}
                            filterLocalStorage={true}
                            cleanFilterLocalStorage={handleClear}

                        />
                    </Col>
              
                </Row>
                <div className='table-responsive'>
                    <DataTable
                        value={comments}
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        className="data-table"
                        emptyMessage={comments.length === 0 && !loading ? (
                            <div className="text-center">
                                <img 
                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} 
                                    style={{ width: "45%" }} 
                                    alt="Sin resultados" 
                                />
                                <br />
                                <p className='badge badge-light-primary mt-2' style={{fontSize: "15px"}}>
                                    No hay coincidencias con la búsqueda.
                                </p>
                            </div>
                        ) : loading ? (
                            <>
                                <Col sm="12" md="12" lg="12" className="text-center pt-5">
                                    <img
                                        alt="Cargando..."
                                        src={require("../../assets/images/loginHelenLabs/HelenLabs.png")}
                                        className="fa-spin"
                                        style={{ width: "15%" }}
                                    />
                                </Col>
                                <Col sm="12" md="12" lg="12" className="text-center mt-1">
                                    <p className="txt-secondary">Cargando...</p>
                                </Col>
                            </>
                        ) : null}
                        

                        
                    >
                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }}
                         headerStyle={headerStyle} style={{ width: "5%", textAlign: "center" }} />
                        
                       <Column
                        field="text"
                        header="Texto"
                        sortable
                        body={(rowData) => (
                            <div style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.4",
                            fontSize: "14px"
                            }}>
                            {rowData.text}
                            </div>
                        )}
                        headerStyle={headerStyle}
                        style={{ width: "85%" }}  
                        />

                        <Column
                        header="Acciones"
                        body={actions}
                        exportable={false}
                        headerStyle={headerStyle}
                        style={{ width: "10%", textAlign: "center" }} 
                        />
                                            

                   

                    </DataTable>

                    
                </div>

                <ModalFooter>
                    <Button size="sm" color="danger" type="button" onClick={closeDialogComments}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Dialog>
            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar comentario global"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlertText}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el comentario?"
                    alert1={true}
                    titleAlert1={selectedComment?.text}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDeleteComment}
                />

            )}
       

            <ModalCrudGlobalComment
                {...{
                    method,
                    handleCreateGlobalComment,
                    modalCrudComment,
                    toggleCrudComment,
                    saveCreate,
                    handleInputChange,
                    text,
                    type,
                    keyComments
                }}
            />
        </>
    );
};
